import { axios } from '@Root/API'

export const get = contactId => {
  return axios.get(`get/contact/${contactId}/admission`)
}
